export const AC_TYPE_NOT_SET = 0;
export const AC_POSITION_NOT_SET = 0;
export interface ACTypeRating {
  readonly acTypeRatingId: number | null;
  active: boolean;
  acTypeId: number | null;
  positionId: number | null;

  //TODO:extra unecessary maps
  crewMemberTypeRatingId: number | null;
  aircraftTypeRatingId: number | null;
  crewMemberTypeId: number | null;

  crewMemberTypeRatingCurrencyTypes: CrewMemberTypeRatingCurrencyType[];
}

export function isACTypeRatingSaved(rating: ACTypeRating | null) {
  return rating && rating.acTypeRatingId && rating.acTypeRatingId > 0;
}

export interface CrewMemberTypeRatingCurrencyType {
  crewMemberTypeRatingCurrencyTypeId: number;
  crewMemberTypeRatingId: number;
  currencyTypeId: number;
  isTracked: boolean;
}
